window.addEventListener("load", function() {
  var links = document.querySelectorAll("a");

  links.forEach(function(link) {
    if (link.href.indexOf("#") !== -1) {
      link.addEventListener("click", function(event) {
        event.preventDefault();
        var targetAnchor = link.getAttribute("href");
        setTimeout(function() {
          window.location.href = targetAnchor;
        });
      });
    }
  });
});